<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>员工管理</el-breadcrumb-item>
      <el-breadcrumb-item>员工档案</el-breadcrumb-item>
    </el-breadcrumb>
    <el-button size="mini" plain @click="toNewEmpCardPage"
               v-if="authorities.includes('storage.inpurchase.send.new')">新建员工档案</el-button>
    <el-date-picker
      v-model="cardRequest.selectDate"
      type="daterange"
      range-separator="至"
      size="mini"
      start-placeholder="请选择入职日期"
      end-placeholder="请选择入职日期"
      @change="selectKpiData"
      value-format="yyyy-MM-dd"
    >
    </el-date-picker>
    <el-select v-model="selectOrgId" v-if="orgLevel == 2" clearable value filterable placeholder="请选择门店"
               style="margin-left: 5px;width: 200px" size="mini" @change="getShop">
      <el-option
        v-for="org in shop"
        :key="org.id"
        :label="org.orgName"
        :value="org.id">
      </el-option>
    </el-select>
    <el-select v-model="selectUserId" clearable value filterable placeholder="请选择职务"
               style="margin-left: 5px;width: 200px" size="mini" @change="getZw">
      <el-option
        v-for="cost in cardZwList"
        :key="cost.zwEnName"
        :label="cost.zwCnName"
        :value="cost.zwCnName">
      </el-option>
    </el-select>
    <el-select v-model="selectedSex" clearable value filterable placeholder="请选择性别"
               style="margin-left: 5px;width: 200px" size="mini" @change="getSexMethod">
      <el-option
        v-for="orgCost in cardSexList"
        :key="orgCost.sexId"
        :label="orgCost.sexName"
        :value="orgCost.sexName">
      </el-option>
    </el-select>
    <el-select v-model="showColumn" clearable value filterable placeholder="请选择类目"
               style="margin-left: 5px;width: 200px" size="mini" @change="getOrgCostMethod">
      <el-option
        v-for="orgCost in cardLmList"
        :key="orgCost.lmEnName"
        :label="orgCost.lmCnName"
        :value="orgCost.lmEnName">
      </el-option>
    </el-select>
    <el-button size="mini" plain @click="loadUserCardList">搜索一下</el-button>
    <el-table height="550px" :data="userCardList" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
              :row-style="{height: '0'}">
      <el-table-column
        label="操作"
        align="center"
        width="100">
        <template slot-scope="scope">
          <div style="display: flex;justify-content: space-evenly">
            <el-link type="primary" icon="el-icon-edit"
                     @click="toEditPage(scope.row)"></el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="userName"
        label="姓名"
        align="center">
      </el-table-column>
      <el-table-column
        prop="sex"
        label="性别"
        align="center">
      </el-table-column>
      <el-table-column
        prop="userPhone"
        label="电话"
        align="center">
      </el-table-column>
      <el-table-column
        prop="shopName"
        label="机构"
        align="center">
      </el-table-column>
      <el-table-column
        prop="position"
        label="职务"
        align="center">
      </el-table-column>
      <el-table-column
        v-if="showColumn == 'sfz'"
        prop="idNum"
        label="身份证号"
        align="center">
      </el-table-column>
      <el-table-column
        v-if="showColumn == 'birthday'"
        prop="birthday"
        label="出生日期"
        align="center">
      </el-table-column>
      <el-table-column
        v-if="showColumn == 'hy'"
        prop="marital"
        label="婚姻状况"
        align="center">
      </el-table-column>
      <el-table-column
        v-if="showColumn == 'zzmm'"
        prop="politics"
        label="政治面貌"
        align="center">
      </el-table-column>
      <el-table-column
        v-if="showColumn == 'sg'"
        prop="height"
        label="身高"
        align="center">
      </el-table-column>
      <el-table-column
        v-if="showColumn == 'fzcm'"
        prop="dressSize"
        label="服装尺码"
        align="center">
      </el-table-column>
      <el-table-column
        v-if="showColumn == 'xzcm'"
        prop="shoeSize"
        label="鞋子尺码"
        align="center">
      </el-table-column>
      <el-table-column
        v-if="showColumn == 'xl'"
        prop="education"
        label="学历"
        align="center">
      </el-table-column>
      <el-table-column
        v-if="showColumn == 'yhk'"
        prop="cardNo"
        label="银行卡号"
        align="center">
      </el-table-column>
      <el-table-column
        v-if="showColumn == 'jrpp'"
        prop="reason"
        label="加入朋朋的原因"
        align="center">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data(){
    return{
      currentOrgId:'',
      orgLevel:'',
      authorities:'',
      userId:'',
      userCardList:[],
      cardLmList:[
        {lmEnName:'sfz', lmCnName:'身份证号'},
        {lmEnName:'birthday', lmCnName:'出生日期'},
        {lmEnName:'hy', lmCnName:'婚姻状况'},
        {lmEnName:'zzmm', lmCnName:'政治面貌'},
        {lmEnName:'sg', lmCnName:'身高'},
        {lmEnName:'fzcm', lmCnName:'服装尺码'},
        {lmEnName:'xzcm', lmCnName:'鞋子尺码'},
        {lmEnName:'xl', lmCnName:'学历'},
        {lmEnName:'yhk', lmCnName:'银行卡号'},
        {lmEnName:'jrpp', lmCnName:'加入朋朋的原因'}
      ],
      cardZwList:[
        {zwEnName:'js', zwCnName:'技师'},
        {zwEnName:'dz', zwCnName:'店长'},
        {zwEnName:'bz', zwCnName:'部长'},
        {zwEnName:'fbz', zwCnName:'副部长'},
        {zwEnName:'gs', zwCnName:'干事'},
        {zwEnName:'jl', zwCnName:'经理'},
      ],
      cardSexList:[
        {sexId:'1', sexName:'男'},
        {sexId:'2', sexName:'女'},
      ],
      cardRequest:{
        selectDate:'',
        startDate:'',
        endDate:'',
        position:'',
        shopName:'',
        sex:'',
      },
      showColumn:'',
      selectOrgId:'',
      selectUserId:'',
      selectedSex:'',
      shop:[]
    }
  },
  methods:{
    toEditPage(item){
      this.$router.push({path:'/edit/user/card',query:{id:item.userId}});
    },
    selectKpiData(){
      if (this.cardRequest.selectDate === null){
        this.cardRequest.startDate = '';
        this.cardRequest.endDate = '';
      } else {
        this.cardRequest.startDate = this.cardRequest.selectDate[0];
        this.cardRequest.endDate = this.cardRequest.selectDate[1];
      }
    },
    toNewEmpCardPage(){
      this.$router.push('/user/card')
    },
    getOrgCostMethod(data){
      this.showColumn = data;
    },
    getSexMethod(data){
      this.cardRequest.sex = data;
    },
    async getShop(data){
      this.selectOrgId = data;
      this.cardRequest.shopName = data.orgName;
      // if (data !== ''){
      //   // const {data:res} = await this.$http.get(`/org/users/${data}`);
      //   // this.shopUserList = res.data;
      // } else {
      //   this.cardRequest.orgId = 0;
      //   // await this.loadAllUser();
      // }
    },
    getZw(data){
      this.cardRequest.position = data;
      // this.selectUserId = data;
      // if (this.selectUserId === ''){
      //   this.cardRequest.userId = 0;
      // } else {
      //   this.cardRequest.userId = data;
      // }
    },
    async loadShopList(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.orgId}`);
      this.shop = res.data;
    },
    async loadUserCardList(){
      const {data:res} = await this.$http.post(`/load/user/cards`, this.cardRequest);
      this.userCardList = res.data;
    },
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadShopList();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  //align-items: flex-start;
  height: 90vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}

.left_con{
  //display: flex;
  //justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: 100px;
}
.left_inner_con{
  width: 100%;
  height: 90vh;
  overflow-y: auto;
}
.left_inner_con::-webkit-scrollbar {
  width: 0 !important
}
.table_container{
  //flex: 1;
  width: 800px;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/UserCardList.vue